module.exports = __webpack_public_path__ + "static/media/Laura Serena.98a2666d.png";